import React, { useState, useEffect } from "react";
import Modal from "react-modal";

const customStyles = {
  overlay: {
    backgroundColor: 'rgba(0, 0, 0, 0.75)',
    zIndex: 9999
  },
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    width: '80%',
    maxWidth: '800px',
    maxHeight: '90vh',
    padding: '0',
    borderRadius: '8px',
    border: 'none',
    boxShadow: '0 5px 15px rgba(0,0,0,0.5)'
  },
};

// Bind modal to app element
Modal.setAppElement('#root');

const MenuSortModal = ({ isOpen, onClose, list, onSave }) => {
  const [treeData, setTreeData] = useState([]);
  
  useEffect(() => {
    if (list && list.data) {
      const processItems = (items, parentId) => {
        const result = [];
        items.forEach(item => {
          if (parseInt(item.status) === 1 && item.parent_id == parentId) {
            const children = processItems(items, item.id);
            result.push({
              ...item,
              isOpen: true,
              children: children
            });
          }
        });
        return result.sort((a, b) => (a.order_id || 0) - (b.order_id || 0));
      };
      
      setTreeData(processItems(list.data, 0));
    }
  }, [list, isOpen]);
  
  const handleDragStart = (e, item) => {
    e.dataTransfer.setData("text/plain", JSON.stringify({id: item.id, parent_id: item.parent_id}));
  };
  
  const handleDrop = (e, targetItem) => {
    e.preventDefault();
    const draggedInfo = JSON.parse(e.dataTransfer.getData("text/plain"));
    
    if (draggedInfo.id === targetItem.id) return;
    if (draggedInfo.parent_id !== targetItem.parent_id) {
        alert("Can only reorder items within the same parent level");
        return;
    }

    const reorderInList = (items) => {
        const newItems = [...items];
        const draggedIdx = newItems.findIndex(i => i.id === draggedInfo.id);
        const targetIdx = newItems.findIndex(i => i.id === targetItem.id);
        
        if (draggedIdx !== -1 && targetIdx !== -1) {
            const [movedItem] = newItems.splice(draggedIdx, 1);
            newItems.splice(targetIdx, 0, movedItem);
            return newItems.map((item, index) => ({ ...item, order_id: index + 1 }));
        }

        return newItems.map(item => {
            if (item.children && item.children.length > 0) {
                return { ...item, children: reorderInList(item.children) };
            }
            return item;
        });
    };

    setTreeData(reorderInList(treeData));
  };
  
  const renderTree = (items, level = 0) => {
    return items.map(item => (
      <div key={item.id} style={{ paddingLeft: `${level * 30}px` }}>
        <div
          className="d-flex align-items-center p-2 border rounded mb-2 bg-light shadow-sm"
          draggable
          onDragStart={(e) => handleDragStart(e, item)}
          onDragOver={(e) => e.preventDefault()}
          onDrop={(e) => handleDrop(e, item)}
          style={{ cursor: 'grab' }}
        >
          <span className="me-3" style={{ color: '#ccc' }}>☰</span>
          <span className="fw-bold">{item.title}</span>
          <div className="ms-auto d-flex align-items-center">
            <span className="badge bg-primary rounded-pill me-2">Pos: {item.order_id}</span>
          </div>
        </div>
        {item.children && item.children.length > 0 && (
          <div className="mt-1">
            {renderTree(item.children, level + 1)}
          </div>
        )}
      </div>
    ));
  };
  
  const flattenTreeToArray = (items) => {
    let result = [];
    const traverse = (items) => {
      items.forEach((item) => {
        result.push({
          id: item.id,
          order_id: item.order_id
        });
        if (item.children && item.children.length > 0) {
          traverse(item.children);
        }
      });
    };
    traverse(items);
    return result;
  };
  
  const handleSave = () => {
    const flattenedData = flattenTreeToArray(treeData);
    onSave(flattenedData);
    onClose();
  };
  
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      style={customStyles}
      contentLabel="Menu Tree Sorting"
    >
      <div className="modal-header p-3 border-bottom bg-primary text-white">
        <h5 className="modal-title m-0">Menu Tree Sorting (Status: Active)</h5>
        <button type="button" className="btn-close btn-close-white" onClick={onClose} aria-label="Close"></button>
      </div>
      <div className="modal-body p-4" style={{ backgroundColor: '#f4f7f6' }}>
        <div className="alert alert-warning mb-4 py-2 small">
          <strong>Tip:</strong> Drag and drop items <strong>within the same level</strong> to rearrange their display order.
        </div>
        <div style={{ maxHeight: '60vh', overflowY: 'auto' }}>
          {treeData.length > 0 ? renderTree(treeData) : <div className="text-center p-5 text-muted">No active menu items found.</div>}
        </div>
      </div>
      <div className="modal-footer p-3 border-top bg-white d-flex justify-content-end">
        <button type="button" className="btn btn-secondary me-2" onClick={onClose}>
          Cancel
        </button>
        <button type="button" className="btn btn-success" onClick={handleSave}>
          Save New Order
        </button>
      </div>
    </Modal>
  );
};

export default MenuSortModal;
